<template>
  <div class="resource-list-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button
        type="primary"
        size="small"
        @click="resourceOperation('add')"
        class="add-input"
        >+新增配置</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
    >
      <el-table-column prop="domain" label="域名" align="left" min-width="400">
        <template slot-scope="scope">
          <!-- <span>{{scope.row.domain || '未知'}}</span> -->
          <p v-for="item in scope.row.domain" :key="item.url">
            <span>权重：{{ item.weight }},</span>
            <span>url：{{ item.url }}</span>
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        label="域名类型"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.type | typeRule }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isActive"
        label="激活状态"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isActive"
            size="small"
            disabled
          ></el-switch>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="updatedAt" label="更新时间" align="center" min-width="240">
        <template slot-scope="scope">
          <span>{{scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="240">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      -->
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="resourceOperation('edit', scope.row)"
          ></el-button>
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="removeResource(scope.row.id)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <!-- 没得分页
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 1" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    -->
    <!--新增、编辑弹框-->
    <resource-action
      ref="resourceAction"
      @handlerResourceList="getResourceList()"
    ></resource-action>
  </div>
</template>

<script>
import API from "@/api";
import ResourceAction from "./components/resourceAction";
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        //pageNumber: 1,
        //pageSize: 10
      },
    };
  },
  components: {
    ResourceAction,
  },
  filters: {
    typeRule(value) {
      let typeList = {
        API: "APP服务域名",
        COMMON: "视频，图片公用(CDN)",
        VID: "视频专用域名(CDN)",
        IMAGE: "图片专用域名(CDN)",
        GROUP: "potato群号",
        TELEGRAM: "telegram群号",
        LAND: "落地页域名",
        GUIDE: "IOS导航域名",
        CUST: "客服中心",
        PROXYRULE: "代理规则",
        FAQ: "问题常见",
        QRCODE: "二维码链接",
        WELFARE: "福利入口",
        ACT: " 活动入口",
        AppStore: "应用商店地址",
        UP: "up主投稿链接",
        Mailbox: "官方邮箱",
      };
      return typeList[value] ? typeList[value] : "未知";
    },
  },
  created() {
    // this.$store.dispatch('setRouterTag', { router: '/administrators', routerName: "系统管理员" })
    this.getResourceList();
  },
  methods: {
    // 请求资源列表
    getResourceList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      API.getSourceList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            // res.data.forEach(item => {
            //   let arr = []
            //   item.domain.forEach(i => {
            //       arr.push(i.url)
            //   })
            //   item.domain = arr.toString()
            // })
            this.tableData = res.data;
            this.total = res.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 删除资源
    removeResource(id) {
      this.$confirm("您确定要删除当前资源吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          API.deleteSource({ ids: [id] }).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "删除资源成功",
                type: "success",
              });
              this.getResourceList();
            } else {
              this.$message.error("删除资源失败");
            }
          });
        })
        .catch(() => {});
    },
    // 新增、编辑操作
    resourceOperation(type, data) {
      this.$refs.resourceAction.open(type, data);
    },
  },
};
</script>

<style lang="scss">
.resource-list-box {
  .add-input {
    margin-left: 0 !important;
  }
}
</style>
